const joinUsModules = document.querySelectorAll('.join-us');

if (joinUsModules.length > 0) {
  let controllerJoinUsModule = null;

  const initJoinUsScrollMagic = () => {
    controllerJoinUsModule = new ScrollMagic.Controller();

    joinUsModules.forEach((parent) => {
      const stickyJoinUsElement = parent.querySelector('.join-us__sticky-part');
      const startPoint = parent.querySelector('.join-us__sticky-start-point');
      const endPoint = parent.querySelector('.join-us__sticky-end-point');
      const contentParent = parent.querySelector('.join-us__left');
      const title = parent.querySelector('.join-us .section-header');

      const scene = new ScrollMagic.Scene({
        triggerElement: startPoint,
        duration: endPoint.offsetTop,
        triggerHook: 0,
      })
        .on('enter', () => {
          toggleActiveClass(contentParent, false);
        })
        .on('progress', (e) => {
          toggleActiveClass(contentParent, e.progress >= 0.9);
        })
        .setPin(stickyJoinUsElement)
        .addTo(controllerJoinUsModule);

      if (isLocal()) {
        scene.addIndicators({ name: 'Sticky Element' });
      }

      if (windowWidth() < breakpointSm) {
        const moveTitle = new TimelineMax();
        moveTitle.to(title, 1, { y: '250px', ease: Power2.easeInOut });
        scene.setTween(moveTitle);
      }
    });
  };

  initJoinUsScrollMagic();
}
